/*eslint no-script-url: 0 */
import React, { Component } from "react";
import { Scrollbars } from 'react-custom-scrollbars';
import Constants from '../../Config/Config';

const URL = Constants.URL.root+'/wp-content/themes/justpictureframing/data/categories-matt.json';

class MattCat extends Component {

  constructor(props) {
    super(props);
    this.state = {
      error: null,
      popularCatCount: 0,
      runAPI: false
    }
  }

  fetchCat() {
    this.setState({ runAPI: true });
    var self = this;
    fetch(URL)
    .then(response => {
      if (!response.ok) {
        throw Error('Network request failed.')
      }
      return response;
    })
    .then(data => data.json())
    .then(data => {
      //console.log(data);
      const categories = data;
      var popularCatCountVar = 0;
      categories.some( ( item ) =>
        popularCatCountVar = item.id === 69 ? item.count : 0
      )
      self.setState({ popularCatCount: popularCatCountVar });
      self.props.dispatch({
        type: 'SET_STATE',
        state: {
          catMattProCount: popularCatCountVar
        }
      })
      var productsCount = 0;
      categories.map(item => (
        //console.log(item.count)
        productsCount = productsCount + item.count
      ))
      //console.log(catCount)
      self.dispatchCatData(categories, productsCount);
    }, (ex) => {
      //self.setState({ error: err.message });
    })
  }

  dispatchCatData(CatData, productsCount) {
    const dataCat = CatData;
    this.props.dispatch({
      type: 'SET_STATE',
      state: {
        matCategories: dataCat,
        mattProductsCount: productsCount
      }
    })
  }

  setCategory = (category, count) => {
    this.props.slidesToShow(count);
    this.props.dispatch({
      type: 'SET_STATE',
      state: {
        displayCategoryMatt: category,
        catMattProCount: count
      }
    })
  };

  componentDidUpdate(prevProps, prevState) {
    if (('layout' === this.props.selectedTab && !this.state.runAPI) || prevProps.showMeHow !== this.props.showMeHow ) {
      this.fetchCat();
    }
  }

  render() {
    //console.log(this.props.productsCount)
    const {displayCategoryMatt} = this.props;
    return (
      <div className="col-sm-3">
        <Scrollbars
          autoHeight
          autoHeightMin={0}
          autoHeightMax={255}
        >
          <ul className="nav nav-tabs">
            <li key="16">
              <a href="#!" className={displayCategoryMatt === 69 ? 'selected-cat' : ''} category="Most Popular" onClick={this.setCategory.bind(this, 69, this.state.popularCatCount)}>Most Popular ({this.state.popularCatCount})</a>
            </li>
            {this.props.matCategories.filter( ( item ) =>
                item.get('id') !== 69
              ).map(item => (
                <li key={item.get('id')}>
                  <a href="#!" className={displayCategoryMatt === item.get('id') ? 'selected-cat' : ''} category={item.get('name')} onClick={this.setCategory.bind(this, item.get('id'), item.get('count'))}>{item.get('name')} ({item.get('count')})</a>
                </li>
            ))}
          </ul>
        </Scrollbars>
      </div>
    );
  }
}
export default MattCat;